<template>
  <button
    type="button"
    class="theme-toggle"
    @click="toggleTheme"
    :title="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
    :aria-label="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
    :aria-pressed="isDarkMode ? 'true' : 'false'"
  >
    <i class="fas" :class="isDarkMode ? 'fa-sun' : 'fa-moon'" aria-hidden="true"></i>Theme Toggle
  </button>
</template>

<script setup lang="ts">
import { useThemeStore } from '@stores/themeStore';
import { storeToRefs } from 'pinia';

const themeStore = useThemeStore();
const { isDarkMode } = storeToRefs(themeStore);
const { toggleTheme } = themeStore;
</script>

<style scoped>
.theme-toggle {
  color: var(--color-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.theme-toggle:hover {
  background-color: var(--bg-tertiary);
}
</style>
